import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none", viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M22.164 14.781a1.425 1.425 0 0 1 0 2.43l-10.306 6.09c-.937.556-2.108-.117-2.108-1.23V9.891c0-1.2 1.259-1.697 2.108-1.2z" }));
const ForwardRef = forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
